export const APP_STORAGE_STORE = 'APP_STORAGE/app'
